export default __webpack_public_path__ + "static/media/remove.69cb0596.svg";